import { render } from "./component-okato.vue?vue&type=template&id=7fcaf41c"
import script from "./component-okato.vue?vue&type=script&setup=true&lang=js"
export * from "./component-okato.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-okato.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7fcaf41c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7fcaf41c', __exports__)) {
    api.reload('7fcaf41c', __exports__)
  }
  
  module.hot.accept("./component-okato.vue?vue&type=template&id=7fcaf41c", () => {
    api.rerender('7fcaf41c', render)
  })

}


export default __exports__